import { render, staticRenderFns } from "./FileStoreDialogNewFolder.vue?vue&type=template&id=5d726501&lang=pug&"
import script from "./FileStoreDialogNewFolder.vue?vue&type=script&lang=js&"
export * from "./FileStoreDialogNewFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports